import * as React from "react";
import { connect } from "react-redux";
import {DeviceComponents, getDeviceSettings} from "../tabDefinition";
import { DeviceHardwareEnum } from "../../DeviceHardwareEnum";
import { SettingEnum } from "../settingEnum";
import styled from "styled-components";
import { AppState } from "@Safemate/Store/types";
import {Capabilities} from "@Safemate/Settings/Store/types";
import {User} from "@Safemate/MyPage/Store/types";
import {SettingDTO} from "@Safemate/Settings/types";

const Wrap = styled.div`
  margin-bottom: 5px;
`;

interface TrackingOptionsProps{
  dehaId: number;
  isPrivate: boolean;
  capabilities: Capabilities;
  user: User;
  tracking: Record<string, SettingDTO>;
}

const mapStateToProps = ({ settings: {device: { device : { dehaId }, deviceSetting}, initialization: {user}}, appData:{isPrivate}}: AppState) => {
  return{
    dehaId,
    isPrivate,
    user,
    tracking: deviceSetting && deviceSetting["settings"] ? deviceSetting["settings"]["tracking"] : undefined
  }
}

const TrackingOptions = connect(mapStateToProps)(({ dehaId, user, isPrivate, capabilities, tracking }: TrackingOptionsProps) => {

  const settings: Map<SettingEnum, JSX.Element[]> = DeviceComponents.has(dehaId) ? DeviceComponents.get(dehaId)! : DeviceComponents.get(DeviceHardwareEnum.DEFAULT)!;
  
  const components: Map<SettingEnum, JSX.Element[]> = getDeviceSettings(dehaId, capabilities, isPrivate, user.beta, settings);

  
  return(
    <React.Fragment>
      {components.has(SettingEnum.TRACKING_OPTIONS) && components.get(SettingEnum.TRACKING_OPTIONS)?.map(comp => <Wrap>{comp}</Wrap>)}

    </React.Fragment>
  )
})

export default TrackingOptions;
